import { Icon } from "@engaging-tech/components"
import styled from "styled-components"

const ClickableIcon = styled(Icon)`
  cursor: pointer;
`

export default ClickableIcon
